export const PIX_CODE_SOURCE_DYNAMIC = "dynamic";
export const PIX_CODE_SOURCE_STATIC = "static";
export const PIX_CODE_SOURCE_DYNAMIC_WITH_STATIC_FALLBACK = "dynamic_with_static_fallback";

export const PIX_KEY_TYPES = [
  { value: "CNPJ", label: "CNPJ" },
  { value: "CPF", label: "CPF" },
  { value: "EMAIL", label: "E-mail" },
  { value: "PHONE", label: "Telefone" },
  { value: "EVP", label: "Chave aleatória" },
];

export function onlyNumbers(value) {
  return String(value || "").replace(/\D/g, "");
}

export function normalizePixKeyType(value, fallback = "CNPJ") {
  const normalized = String(value || "").trim().toUpperCase();
  return PIX_KEY_TYPES.some((item) => item.value === normalized) ? normalized : fallback;
}

export function resolveAccountPixDefaults(profile = {}) {
  const document = profile?.cpf_cnpj || profile?.document_number || "";
  const documentDigits = onlyNumbers(document);
  const accountName =
    profile?.trade_name ||
    profile?.legal_name ||
    profile?.account_name ||
    profile?.name ||
    "";

  return {
    merchant_name: String(accountName || "").trim(),
    key: documentDigits,
    key_type: documentDigits.length === 11 ? "CPF" : "CNPJ",
  };
}

function valueOrDefault(value, fallback = "") {
  const normalized = String(value ?? "").trim();
  return normalized || String(fallback ?? "").trim();
}

export function normalizePixConfig(config = {}, defaults = {}) {
  const codeSource = [
    PIX_CODE_SOURCE_DYNAMIC,
    PIX_CODE_SOURCE_STATIC,
    PIX_CODE_SOURCE_DYNAMIC_WITH_STATIC_FALLBACK,
  ].includes(config?.code_source)
    ? config.code_source
    : PIX_CODE_SOURCE_DYNAMIC;
  const keyType = normalizePixKeyType(config?.key_type, defaults?.key_type || "CNPJ");
  const key = valueOrDefault(config?.key, defaults?.key);
  const staticCode = valueOrDefault(config?.static_code, defaults?.static_code);

  return {
    code_source: codeSource,
    static_code: staticCode,
    merchant_name: valueOrDefault(config?.merchant_name, defaults?.merchant_name),
    key,
    key_type: keyType,
  };
}

export function pixConfigUsesManualCode(config = {}) {
  return (
    config?.code_source === PIX_CODE_SOURCE_STATIC ||
    config?.code_source === PIX_CODE_SOURCE_DYNAMIC_WITH_STATIC_FALLBACK
  );
}

export function isPixConfigComplete(config = {}) {
  const codeSource = config?.code_source || PIX_CODE_SOURCE_DYNAMIC;
  const validCodeSource = [
    PIX_CODE_SOURCE_DYNAMIC,
    PIX_CODE_SOURCE_STATIC,
    PIX_CODE_SOURCE_DYNAMIC_WITH_STATIC_FALLBACK,
  ].includes(codeSource);

  if (!validCodeSource) return false;
  if (pixConfigUsesManualCode(config) && !String(config?.key || config?.static_code || "").trim()) {
    return false;
  }

  return true;
}
